import _defineProperty from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["style", "titleText", "subtitleText", "subtitleTextLink", "subtitleLink", "buttonText", "buttonIcon", "onButtonClick", "LinkComponent", "disabledFadeIn", "buttonLink", "scrollElement", "subtitleStyle", "fadeInAutoPlay", "textOnly", "isMobile", "ecosystem", "step", "onClick"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React__default, { Fragment } from 'react';
import styled from 'styled-components';
import '../../App.css.js';
import img$1 from '../../images/button-app-store.svg.js';
import img from '../../images/button-play-store.svg.js';
import Text from '../text/text.component.js';
var TextTitle = styled(Text).withConfig({
  displayName: "landing-header-ecosystemcomponent__TextTitle",
  componentId: "sc-1jeqy8x-0"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:56px;line-height:67px;}"]);
var TextDescription = styled(Text).withConfig({
  displayName: "landing-header-ecosystemcomponent__TextDescription",
  componentId: "sc-1jeqy8x-1"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Medium,Arial;font-weight:500;font-size:24px;line-height:31px;}"]);
var ContainerButtons = styled.div.withConfig({
  displayName: "landing-header-ecosystemcomponent__ContainerButtons",
  componentId: "sc-1jeqy8x-2"
})(["display:flex;flex-direction:row;align-items:center;margin-top:34px;& > * + *{margin-left:16px;}a{height:56px;}@media screen and (max-width:768px){display:flex;flex-direction:row;align-items:center;justify-content:center;margin-top:34px;min-width:100%;a{height:40px;}& > * + *{margin-left:8px;}}"]);
var Image = styled.img.withConfig({
  displayName: "landing-header-ecosystemcomponent__Image",
  componentId: "sc-1jeqy8x-3"
})(["height:56px;@media screen and (max-width:768px){height:40px;}"]);
var LandingHeaderNormal = function LandingHeaderNormal(_ref) {
  var style = _ref.style,
    titleText = _ref.titleText,
    subtitleText = _ref.subtitleText,
    subtitleTextLink = _ref.subtitleTextLink,
    subtitleLink = _ref.subtitleLink,
    buttonText = _ref.buttonText,
    buttonIcon = _ref.buttonIcon,
    onButtonClick = _ref.onButtonClick,
    LinkComponent = _ref.LinkComponent,
    disabledFadeIn = _ref.disabledFadeIn,
    buttonLink = _ref.buttonLink,
    scrollElement = _ref.scrollElement,
    subtitleStyle = _ref.subtitleStyle,
    fadeInAutoPlay = _ref.fadeInAutoPlay,
    textOnly = _ref.textOnly,
    isMobile = _ref.isMobile,
    ecosystem = _ref.ecosystem,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? false : _ref$step,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TextTitle, {
    fontFamily: "euclid",
    type: "display",
    tag: "h1",
    fontSize: "xxlarge",
    style: {
      marginBottom: "0px",
      maxWidth: "100%",
      paddingLeft: "24px",
      paddingRight: "24px",
      boxSizing: "border-box",
      marginTop: "0px",
      textAlign: "center",
      whiteSpace: "break-spaces"
      /*opacity: 0,
      animationName: "textHeaderFadeIn",
      animationDuration: "1s",
      animationDelay: "1s",
      animationFillMode: "forwards",*/
    }
  }, titleText), /*#__PURE__*/React__default.createElement(TextDescription, {
    className: "subtitle-header",
    fontFamily: "euclid",
    type: "heading",
    fontSize: "xlargeM",
    color: "grey-1",
    style: _objectSpread({
      marginTop: "24px",
      textAlign: "center",
      maxWidth: "100%",
      paddingLeft: "24px",
      paddingRight: "24px",
      boxSizing: "border-box"
    }, subtitleStyle)
  }, subtitleText, " ", subtitleTextLink && subtitleLink && subtitleLink.lastIndexOf("http") >= 0 ? /*#__PURE__*/React__default.createElement("a", {
    href: subtitleLink,
    target: "_blank",
    title: subtitleTextLink,
    style: {
      color: "var(--green)"
    }
  }, subtitleTextLink) : subtitleTextLink ? /*#__PURE__*/React__default.createElement(LinkComponent, {
    to: subtitleLink,
    title: subtitleTextLink,
    style: {
      color: "var(--green)",
      textDecoration: "none"
    }
  }, subtitleTextLink) : null), textOnly ? null : /*#__PURE__*/React__default.createElement(ContainerButtons, null, /*#__PURE__*/React__default.createElement("a", {
    href: step ? "https://youngplatform.page.link/XLkB" : "https://youngexchange.page.link/dr8x",
    onClick: onClick,
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React__default.createElement(Image, {
    width: isMobile ? "134" : "188",
    height: isMobile ? "40" : "56",
    src: img
  })), /*#__PURE__*/React__default.createElement("a", {
    href: step ? "https://youngplatform.page.link/cuVF" : "https://youngexchange.page.link/sBwZ",
    onClick: onClick,
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React__default.createElement(Image, {
    width: isMobile ? "134" : "188",
    height: isMobile ? "40" : "56",
    src: img$1
  }))));
};
export { LandingHeaderNormal as default };